import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import Pagination from '@/components/pagination-new/Pagination';
import useScrollToTop from '@/hooks/useScrollToTop';
import useQuery from './useQuery';
import PaginationInformation from '@/components/pagination-new/PaginationInformation';

SupportQuestions.propTypes = {
  children: PropTypes.func.isRequired,
  router: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string
    })
  })
};

export default function SupportQuestions(props) {
  const { router, children } = props;
  const { location } = router;

  const search = queryString.parse(location.search);

  const node = useRef();
  const scrollToTop = useScrollToTop();

  const pageSize = 20;

  const result = useQuery({
    search,
    pageSize
  });

  return (
    <>
      <div ref={node} className="flex flex-wrap gap-4 justify-between items-end">
        <PaginationInformation
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
        />
      </div>
      {children(result)}
      <div className="flex flex-wrap gap-4 items-center justify-between">
        <PaginationInformation
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
        />
        <Pagination
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
          onNavigate={() => scrollToTop(node)}
        />
      </div>
    </>
  );
}
